import { createAction } from "@reduxjs/toolkit";

const setMetadataAsyncAction = createAction("SET_METADATA_ASYNC");

export default setMetadataAsyncAction;
